
import axios from './http.js'


const http = {
  getYuanYouCpy(){
    return axios.get('/cpyView/cpy/yycpy')
  },
  getShanDong(){
    return axios.get('/cpyView/cpy/sddlgjqy')
  },
  getLianYouNengLi(){
    return axios.get('/cpyView/cpy/right/up/cpycn')
  },
  getZhiBiaoKa(){
    return axios.get('/cpyView/cpy/zbk')
  },
  getMap(){
    return axios.get('/cpyView/cpy/chart')
  },
  getChanLiang(){
    return axios.get('/cpyView/cpy/right/down/qycl')
  },
  getYYBHL(){
    return axios.get('/cpyView/cpy/yybhl')
  },
  getChukouLiang(){
    return axios.get('/cpyView/cpy/right/down/ckl')
  },
  getQiYouBiaoGuan(){
    return axios.get('/cpyView/cpy/mid/down/left/qybxxfg')
  },
  getChaiYouBiaoGuan(){
    return axios.get('/cpyView/cpy/mid/down/right/cybxxfg')
  },
  getDiFangLianYouGuan(){
    return axios.get('/cpyView/cpy/cnzb')
  },
}

export default http


